module.exports = __webpack_public_path__ + "e-learning-app/static/img/head3.0e1ce0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-area/img/ne/head3.png
// module id = gSr+
// module chunks = 1